// src/versioning/VersionContext.tsx
import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router';

type Version = 'v1' | 'v2' | 'v2-online' | 'v2-cc';

const VersionContext = createContext<Version>('v2-online');

function deriveVersionFromPath(pathname: string): Version {
  // match "/v2" at a segment boundary: "/v2", "/v2/", "/v2/something"

  // const isV2 = /(^|\/)v2(\/|$)/i.test(pathname) ? 'v2' : 'v2';

  // if (isV2 === 'v1') return 'v1';

  const isOnline = /(^|\/)contactcenter(\/|$)/i.test(pathname) ? 'v2-cc' : 'v2-online';

  // const isOnline = /(^|\/)(\/|$)/i.test(pathname) ? 'v2-online' : 'v2-cc';

  return isOnline;
}

export function VersionProvider({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();

  // const pathname = '/v2';

  // Recompute whenever the URL changes
  const version = useMemo<Version>(() => deriveVersionFromPath(pathname), [pathname]);

  return <VersionContext.Provider value={version}>{children}</VersionContext.Provider>;
}

export function useAppVersion() {
  return useContext(VersionContext);
}
